import React from 'react';
import { Form } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { MultiSelect } from './inputs/MultiSelect';

export const BranchOfficeFilter = ({
  setFiltersAndSort,
  filtersAndSort,
  branchOffices,
  showTitle = true
}) => {
  const onChange = selected => {
    setFiltersAndSort({
      ...filtersAndSort,
      branchOffices: selected.map(s => s.value)
    });
  };

  const options = branchOffices.map(bo => ({
    value: bo.id,
    label: bo.branch_office_name
  }));

  const value = filtersAndSort.branchOffices.map(boId => ({
    value: boId,
    label: branchOffices.find(bo => bo.id === boId)?.branch_office_name
  }));

  return (
    <Form.Group>
      {showTitle && <Form.Label>Sucursales</Form.Label>}

      <MultiSelect
        options={options}
        value={value}
        onChange={onChange}
        placeholder="Sucursales"
      />
    </Form.Group>
  );
};

BranchOfficeFilter.propTypes = {
  setFiltersAndSort: PropTypes.func.isRequired,
  filtersAndSort: PropTypes.object.isRequired,
  branchOffices: PropTypes.array.isRequired,
  showTitle: PropTypes.bool
};
